module.exports = __webpack_public_path__ + "static/media/truck-banesco.0cf92343.svg";